export const categories = [
  { id: 'dianying', name: '电影', slug: 'dianying', icon: 'ri-film-line' },
  { id: 'dianshiju', name: '电视剧', slug: 'dianshiju', icon: 'ri-tv-line' },
  { id: 'zongyi', name: '综艺', slug: 'zongyi', icon: 'ri-emotion-laugh-line' },
  { id: 'dongman', name: '动漫', slug: 'dongman', icon: 'ri-ghost-smile-line' },
  { id: 'jilupian', name: '纪录片', slug: 'jilupian', icon: 'ri-global-line' },
  { id: 'tiyu', name: '体育', slug: 'tiyu', icon: 'ri-basketball-line' },
  { id: 'yinyue', name: '音乐', slug: 'yinyue', icon: 'ri-music-line' },
  { id: 'youxi', name: '游戏', slug: 'youxi', icon: 'ri-gamepad-line' },
];

export const videos = [
  {
    id: 1,
    title: '流浪地球3：星辰大海',
    category: 'dianying',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20astronauts%20and%20massive%20spaceship%20in%20deep%20space%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20orange%20and%20deep%20blue%20color%20palette%2C%20movie%20poster%20style&width=640&height=360&seq=video-cover-01&orientation=landscape',
    rating: 9.2,
    duration: '148分钟',
    year: 2026,
    description: '人类文明在浩瀚宇宙中继续探索，面对未知的挑战，团结与勇气是唯一的答案。',
    tags: ['科幻', '冒险', '国产'],
    views: '1280万',
    isHot: true,
    isNew: true,
  },
  {
    id: 2,
    title: '繁花似锦：沪上风云',
    category: 'dianshiju',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20poster%20set%20in%201990s%20Shanghai%2C%20vintage%20aesthetic%2C%20warm%20golden%20tones%2C%20nostalgic%20atmosphere%2C%20cinematic%20photography%2C%20chinese%20drama%20series%20poster&width=640&height=360&seq=video-cover-02&orientation=landscape',
    rating: 9.5,
    duration: '40集',
    year: 2026,
    description: '九十年代上海滩，商海沉浮间，一段跨越时代的爱恨情仇徐徐展开。',
    tags: ['都市', '情感', '年代'],
    views: '2560万',
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '极限挑战第十季',
    category: 'zongyi',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20doing%20outdoor%20challenges%2C%20colorful%20and%20energetic%2C%20fun%20atmosphere%2C%20bright%20lighting%2C%20entertainment%20show%20poster&width=640&height=360&seq=video-cover-03&orientation=landscape',
    rating: 8.8,
    duration: '12期',
    year: 2026,
    description: '新一季极限挑战重磅回归！全新嘉宾阵容，更多爆笑挑战，极限无处不在！',
    tags: ['真人秀', '搞笑', '挑战'],
    views: '3890万',
    isHot: true,
    isNew: true,
  },
  {
    id: 4,
    title: '鬼灭之刃：无限城篇',
    category: 'dongman',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20movie%20poster%20with%20samurai%20characters%20in%20dynamic%20action%20poses%2C%20fire%20and%20water%20effects%2C%20dramatic%20Japanese%20animation%20style%2C%20dark%20background%20with%20vibrant%20color%20accents&width=640&height=360&seq=video-cover-04&orientation=landscape',
    rating: 9.7,
    duration: '120分钟',
    year: 2026,
    description: '炭治郎与伙伴们深入无限城，与上弦之鬼的最终决战一触即发。',
    tags: ['热血', '战斗', '日漫'],
    views: '4560万',
    isHot: true,
    isNew: true,
  },
  {
    id: 5,
    title: '地球脉动IV：深海秘境',
    category: 'jilupian',
    cover: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20deep%20ocean%20creatures%2C%20bioluminescent%20jellyfish%20and%20whales%2C%20mysterious%20underwater%20world%2C%20cinematic%20photography%2C%20dark%20blue%20and%20teal%20tones&width=640&height=360&seq=video-cover-05&orientation=landscape',
    rating: 9.8,
    duration: '6集',
    year: 2026,
    description: '潜入从未被人类探索过的深海世界，见证大自然最震撼的生命奇迹。',
    tags: ['自然', '海洋', 'BBC'],
    views: '980万',
    isHot: false,
    isNew: true,
  },
  {
    id: 6,
    title: 'NBA季后赛：巅峰对决',
    category: 'tiyu',
    cover: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20playoff%20poster%20with%20players%20dunking%2C%20intense%20arena%20atmosphere%2C%20dramatic%20sports%20photography%2C%20spotlight%20effects%2C%20energetic%20and%20powerful&width=640&height=360&seq=video-cover-06&orientation=landscape',
    rating: 9.1,
    duration: '全场回放',
    year: 2026,
    description: '季后赛最精彩的对决集锦，每一球都让人热血沸腾，重温经典瞬间。',
    tags: ['篮球', 'NBA', '体育'],
    views: '2100万',
    isHot: true,
    isNew: false,
  },
  {
    id: 7,
    title: '乘风破浪的姐姐 第五季',
    category: 'zongyi',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20singing%20competition%20show%20poster%20with%20elegant%20female%20performers%20on%20stage%2C%20glamorous%20stage%20lighting%2C%20sparkling%20effects%2C%20music%20entertainment%20show&width=640&height=360&seq=video-cover-07&orientation=landscape',
    rating: 8.6,
    duration: '15期',
    year: 2026,
    description: '三十位姐姐再次集结，用舞台证明年龄只是数字，梦想永远年轻。',
    tags: ['音乐', '竞演', '女性'],
    views: '5670万',
    isHot: true,
    isNew: false,
  },
  {
    id: 8,
    title: '长安三万里2：大唐新篇',
    category: 'dongman',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20set%20in%20ancient%20Tang%20Dynasty%2C%20poets%20and%20warriors%20in%20traditional%20clothing%2C%20beautiful%20ancient%20Chinese%20cityscape%2C%20ink%20painting%20style%2C%20elegant&width=640&height=360&seq=video-cover-08&orientation=landscape',
    rating: 9.4,
    duration: '168分钟',
    year: 2026,
    description: '续写大唐诗人们的传奇故事，以诗为剑，以梦为马，再绘盛世长安。',
    tags: ['历史', '国漫', '诗词'],
    views: '3450万',
    isHot: false,
    isNew: true,
  },
  {
    id: 9,
    title: '狂飙：风云再起',
    category: 'dianshiju',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20with%20intense%20police%20and%20gangster%20confrontation%2C%20dark%20urban%20night%20scene%2C%20dramatic%20noir%20lighting%2C%20suspenseful%20atmosphere&width=640&height=360&seq=video-cover-09&orientation=landscape',
    rating: 9.6,
    duration: '36集',
    year: 2026,
    description: '扫黑除恶专项行动再掀风暴，正与邪的较量在一座城市中激烈上演。',
    tags: ['悬疑', '犯罪', '正剧'],
    views: '6780万',
    isHot: true,
    isNew: true,
  },
  {
    id: 10,
    title: '周杰伦2026世界巡回演唱会',
    category: 'yinyue',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20pop%20music%20concert%20poster%20with%20singer%20on%20massive%20stage%2C%20colorful%20laser%20lights%2C%20huge%20crowd%2C%20energetic%20live%20performance%2C%20spectacular%20visual%20effects&width=640&height=360&seq=video-cover-10&orientation=landscape',
    rating: 9.9,
    duration: '180分钟',
    year: 2026,
    description: '华语乐坛天王周杰伦最新世界巡演，经典金曲一次听够，视听盛宴不容错过。',
    tags: ['演唱会', '华语', '音乐'],
    views: '8900万',
    isHot: true,
    isNew: true,
  },
  {
    id: 11,
    title: '王者荣耀：电竞巅峰赛',
    category: 'youxi',
    cover: 'https://readdy.ai/api/search-image?query=Esports%20tournament%20poster%20with%20game%20characters%20and%20trophy%2C%20futuristic%20arena%20stage%2C%20neon%20lights%2C%20competitive%20gaming%20atmosphere%2C%20dynamic%20and%20exciting&width=640&height=360&seq=video-cover-11&orientation=landscape',
    rating: 8.9,
    duration: '全场回放',
    year: 2026,
    description: '年度电竞盛典，顶尖战队巅峰对决，每一场都是教科书级别的操作。',
    tags: ['电竞', 'MOBA', '手游'],
    views: '2340万',
    isHot: false,
    isNew: false,
  },
  {
    id: 12,
    title: '舌尖上的中国 第五季',
    category: 'jilupian',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20beautiful%20traditional%20dishes%2C%20steaming%20hot%20food%2C%20warm%20kitchen%20atmosphere%2C%20appetizing%20food%20photography%2C%20cultural%20cooking%20scene&width=640&height=360&seq=video-cover-12&orientation=landscape',
    rating: 9.3,
    duration: '8集',
    year: 2026,
    description: '走遍大江南北，探寻最地道的中国味道，每一口都是家乡的记忆。',
    tags: ['美食', '文化', '纪录片'],
    views: '1560万',
    isHot: false,
    isNew: true,
  },
];

export const articles = [
  {
    id: 1,
    title: '2026年最值得期待的十部国产大片，每一部都是王炸',
    excerpt: '随着中国电影工业的不断成熟，2026年将迎来一波国产大片的爆发期。从科幻巨制到历史史诗，让我们一起来看看今年最值得期待的十部电影。',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20movie%20theater%20interior%20with%20red%20curtains%20and%20golden%20decorations%2C%20luxurious%20atmosphere%2C%20cinematic%20photography%2C%20warm%20lighting%2C%20elegant%20composition&width=800&height=450&seq=article-cover-01&orientation=landscape',
    category: 'dianying',
    author: '影视观察员',
    date: '2026-07-28',
    readTime: '8分钟',
    views: '12.5万',
    tags: ['电影推荐', '国产大片', '2026'],
  },
  {
    id: 2,
    title: '《繁花似锦》爆火背后：年代剧为何总能戳中观众泪点',
    excerpt: '近期热播的年代剧《繁花似锦》收视率屡创新高，豆瓣评分高达9.5分。这部剧为何能在众多影视作品中脱颖而出？年代剧的魅力究竟在哪里？',
    cover: 'https://readdy.ai/api/search-image?query=Vintage%201990s%20Shanghai%20street%20scene%20with%20old%20cars%20and%20neon%20signs%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20evening%20light%2C%20cinematic%20street%20photography&width=800&height=450&seq=article-cover-02&orientation=landscape',
    category: 'dianshiju',
    author: '剧评人小李',
    date: '2026-07-26',
    readTime: '6分钟',
    views: '9.8万',
    tags: ['繁花似锦', '年代剧', '剧评'],
  },
  {
    id: 3,
    title: '从《鬼灭之刃》到《长安三万里》：动漫电影为何频频破圈',
    excerpt: '近年来，无论是日漫还是国漫，动漫电影频频创造票房奇迹。从二次元文化到全民观影热潮，动漫电影正在重新定义中国电影市场的格局。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20and%20Chinese%20animation%20movie%20posters%20displayed%20together%20in%20a%20modern%20gallery%2C%20colorful%20vibrant%20art%2C%20creative%20exhibition%20space%2C%20cultural%20fusion&width=800&height=450&seq=article-cover-03&orientation=landscape',
    category: 'dongman',
    author: '动漫达人',
    date: '2026-07-25',
    readTime: '7分钟',
    views: '15.2万',
    tags: ['动漫', '国漫', '日漫', '票房'],
  },
  {
    id: 4,
    title: '综艺节目三十年：从《正大综艺》到《极限挑战》，我们变了什么',
    excerpt: '中国综艺节目走过了三十年的历程，从最初的引进模式到如今的原创爆发，综艺市场经历了怎样的变迁？未来又将走向何方？',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20variety%20show%20evolution%20timeline%20collage%2C%20from%20retro%20to%20modern%20studio%20setups%2C%20colorful%20entertainment%20history%2C%20creative%20composition&width=800&height=450&seq=article-cover-04&orientation=landscape',
    category: 'zongyi',
    author: '娱乐研究员',
    date: '2026-07-24',
    readTime: '10分钟',
    views: '8.3万',
    tags: ['综艺', '娱乐史', '中国电视'],
  },
  {
    id: 5,
    title: '纪录片推荐：五部让你重新认识这个世界的深度之作',
    excerpt: '好的纪录片就像一扇窗，让我们看到世界不同的面貌。今天为大家推荐五部2026年不容错过的纪录片，每一部都能颠覆你的认知。',
    cover: 'https://readdy.ai/api/search-image?query=Documentary%20film%20collection%20display%20with%20nature%20and%20culture%20themes%2C%20artistic%20arrangement%20of%20film%20stills%2C%20educational%20and%20inspiring%20atmosphere%2C%20clean%20modern%20layout&width=800&height=450&seq=article-cover-05&orientation=landscape',
    category: 'jilupian',
    author: '纪录片狂热者',
    date: '2026-07-23',
    readTime: '9分钟',
    views: '6.7万',
    tags: ['纪录片', '推荐', '深度'],
  },
  {
    id: 6,
    title: '周杰伦2026巡演首站直击：当青春再次被唱响',
    excerpt: '周杰伦2026世界巡回演唱会首站圆满落幕，三个小时的视听盛宴让无数歌迷泪洒现场。这是属于一代人的青春回忆，也是华语乐坛的又一次里程碑。',
    cover: 'https://readdy.ai/api/search-image?query=Massive%20concert%20crowd%20with%20colorful%20stage%20lighting%20and%20laser%20effects%2C%20energetic%20live%20music%20performance%2C%20spectacular%20atmosphere%2C%20wide%20angle%20view&width=800&height=450&seq=article-cover-06&orientation=landscape',
    category: 'yinyue',
    author: '音乐现场记者',
    date: '2026-07-22',
    readTime: '5分钟',
    views: '23.1万',
    tags: ['周杰伦', '演唱会', '华语乐坛'],
  },
];

export const siteInfo = {
  name: '樱桃视频',
  slogan: '免费高清，流畅观影',
  description: '樱桃视频致力于为广大用户提供免费、高清、流畅的在线影视观看体验。聚合海量优质影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等多个分类，让每一位用户都能找到自己喜欢的精彩内容。',
  founded: '2020年',
  users: '5000万+',
  videos: '10万+',
  dailyActive: '800万+',
};

export const aboutContent = {
  intro: '樱桃视频成立于2020年，是国内领先的免费高清影视内容聚合平台。我们始终秉持"让每个人都能轻松享受高品质影视内容"的使命，通过先进的技术架构和优质的内容筛选机制，为用户提供流畅、高清、丰富的观影体验。',
  mission: '我们的愿景是成为华语地区最受欢迎的免费影视平台，让优质内容触手可及。',
  features: [
    { title: '海量资源', description: '涵盖电影、电视剧、综艺、动漫、纪录片等10万+优质内容，每日更新。', icon: 'ri-database-2-line' },
    { title: '高清画质', description: '支持1080P/4K超高清画质，带来影院级视觉享受。', icon: 'ri-4k-line' },
    { title: '流畅不卡顿', description: '采用先进的CDN加速技术，确保播放流畅不缓冲。', icon: 'ri-speed-up-line' },
    { title: '完全免费', description: '所有内容完全免费观看，无需会员，无需付费。', icon: 'ri-vip-crown-line' },
  ],
  testimonials: [
    { name: '张先生', avatar: '', text: '樱桃视频真的太好用了！资源丰富，画质清晰，最重要的是完全免费。现在全家人的追剧都靠它了。', rating: 5 },
    { name: '李女士', avatar: '', text: '作为一个电影爱好者，樱桃视频满足了我所有的观影需求。更新速度快，分类清晰，强烈推荐！', rating: 5 },
    { name: '王同学', avatar: '', text: '自从用了樱桃视频，再也不用到处找资源了。动漫、综艺、电影应有尽有，界面也很简洁好用。', rating: 5 },
    { name: '赵先生', avatar: '', text: '老用户了，看着樱桃视频一步步成长起来的。现在的体验越来越好，流畅度和画质都在不断提升。', rating: 5 },
  ],
  contact: {
    email: 'contact@yingtaovideo.com',
    wechat: 'yingtaovideo_official',
    weibo: '@樱桃视频官方',
    address: '北京市朝阳区望京科技园',
  },
};